/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestMapleV2Pool extends Contract<ITestMapleV2Pool> {
  allowance: Call<(owner: AddressLike, spender: AddressLike) => BigNumber, ITestMapleV2Pool>
  'allowance(address,address)': Call<(owner: AddressLike, spender: AddressLike) => BigNumber, ITestMapleV2Pool>
  approve: Send<(spender: AddressLike, amount: BigNumberish) => boolean, ITestMapleV2Pool>
  'approve(address,uint256)': Send<(spender: AddressLike, amount: BigNumberish) => boolean, ITestMapleV2Pool>
  asset: Call<() => string, ITestMapleV2Pool>
  'asset()': Call<() => string, ITestMapleV2Pool>
  balanceOf: Call<(account: AddressLike) => BigNumber, ITestMapleV2Pool>
  'balanceOf(address)': Call<(account: AddressLike) => BigNumber, ITestMapleV2Pool>
  convertToAssets: Call<(_shares: BigNumberish) => BigNumber, ITestMapleV2Pool>
  'convertToAssets(uint256)': Call<(_shares: BigNumberish) => BigNumber, ITestMapleV2Pool>
  convertToExitAssets: Call<(_shares: BigNumberish) => BigNumber, ITestMapleV2Pool>
  'convertToExitAssets(uint256)': Call<(_shares: BigNumberish) => BigNumber, ITestMapleV2Pool>
  convertToExitShares: Call<(_assets: BigNumberish) => BigNumber, ITestMapleV2Pool>
  'convertToExitShares(uint256)': Call<(_assets: BigNumberish) => BigNumber, ITestMapleV2Pool>
  convertToShares: Call<(_assets: BigNumberish) => BigNumber, ITestMapleV2Pool>
  'convertToShares(uint256)': Call<(_assets: BigNumberish) => BigNumber, ITestMapleV2Pool>
  deposit: Send<(_assets: BigNumberish, _receiver: AddressLike) => BigNumber, ITestMapleV2Pool>
  'deposit(uint256,address)': Send<(_assets: BigNumberish, _receiver: AddressLike) => BigNumber, ITestMapleV2Pool>
  manager: Call<() => string, ITestMapleV2Pool>
  'manager()': Call<() => string, ITestMapleV2Pool>
  maxDeposit: Call<(_receiver: AddressLike) => BigNumber, ITestMapleV2Pool>
  'maxDeposit(address)': Call<(_receiver: AddressLike) => BigNumber, ITestMapleV2Pool>
  maxMint: Call<(_receiver: AddressLike) => BigNumber, ITestMapleV2Pool>
  'maxMint(address)': Call<(_receiver: AddressLike) => BigNumber, ITestMapleV2Pool>
  maxRedeem: Call<(_owner: AddressLike) => BigNumber, ITestMapleV2Pool>
  'maxRedeem(address)': Call<(_owner: AddressLike) => BigNumber, ITestMapleV2Pool>
  maxWithdraw: Call<(_owner: AddressLike) => BigNumber, ITestMapleV2Pool>
  'maxWithdraw(address)': Call<(_owner: AddressLike) => BigNumber, ITestMapleV2Pool>
  mint: Send<(shares_: BigNumberish, _receiver: AddressLike) => BigNumber, ITestMapleV2Pool>
  'mint(uint256,address)': Send<(shares_: BigNumberish, _receiver: AddressLike) => BigNumber, ITestMapleV2Pool>
  previewDeposit: Call<(_assets: BigNumberish) => BigNumber, ITestMapleV2Pool>
  'previewDeposit(uint256)': Call<(_assets: BigNumberish) => BigNumber, ITestMapleV2Pool>
  previewMint: Call<(_shares: BigNumberish) => BigNumber, ITestMapleV2Pool>
  'previewMint(uint256)': Call<(_shares: BigNumberish) => BigNumber, ITestMapleV2Pool>
  previewRedeem: Call<(_shares: BigNumberish) => BigNumber, ITestMapleV2Pool>
  'previewRedeem(uint256)': Call<(_shares: BigNumberish) => BigNumber, ITestMapleV2Pool>
  previewWithdraw: Call<(_assets: BigNumberish) => BigNumber, ITestMapleV2Pool>
  'previewWithdraw(uint256)': Call<(_assets: BigNumberish) => BigNumber, ITestMapleV2Pool>
  redeem: Send<(_shares: BigNumberish, _receiver: AddressLike, _owner: AddressLike) => BigNumber, ITestMapleV2Pool>
  'redeem(uint256,address,address)': Send<(_shares: BigNumberish, _receiver: AddressLike, _owner: AddressLike) => BigNumber, ITestMapleV2Pool>
  totalAssets: Call<() => BigNumber, ITestMapleV2Pool>
  'totalAssets()': Call<() => BigNumber, ITestMapleV2Pool>
  totalSupply: Call<() => BigNumber, ITestMapleV2Pool>
  'totalSupply()': Call<() => BigNumber, ITestMapleV2Pool>
  transfer: Send<(recipient: AddressLike, amount: BigNumberish) => boolean, ITestMapleV2Pool>
  'transfer(address,uint256)': Send<(recipient: AddressLike, amount: BigNumberish) => boolean, ITestMapleV2Pool>
  transferFrom: Send<(sender: AddressLike, recipient: AddressLike, amount: BigNumberish) => boolean, ITestMapleV2Pool>
  'transferFrom(address,address,uint256)': Send<(sender: AddressLike, recipient: AddressLike, amount: BigNumberish) => boolean, ITestMapleV2Pool>
  withdraw: Send<(_assets: BigNumberish, _receiver: AddressLike, _owner: AddressLike) => BigNumber, ITestMapleV2Pool>
  'withdraw(uint256,address,address)': Send<(_assets: BigNumberish, _receiver: AddressLike, _owner: AddressLike) => BigNumber, ITestMapleV2Pool>
}

let ITestMapleV2PoolBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestMapleV2PoolBytecode = '0x';
}

// prettier-ignore
export const ITestMapleV2Pool = contract<ITestMapleV2Pool>(ITestMapleV2PoolBytecode)`
  event Approval(address indexed owner, address indexed spender, uint256 value)
  event Transfer(address indexed from, address indexed to, uint256 value)
  function allowance(address owner, address spender) view returns (uint256)
  function approve(address spender, uint256 amount) returns (bool)
  function asset() view returns (address asset_)
  function balanceOf(address account) view returns (uint256)
  function convertToAssets(uint256 _shares) view returns (uint256 assets_)
  function convertToExitAssets(uint256 _shares) view returns (uint256 assets_)
  function convertToExitShares(uint256 _assets) view returns (uint256 shares_)
  function convertToShares(uint256 _assets) view returns (uint256 shares_)
  function deposit(uint256 _assets, address _receiver) returns (uint256 shares_)
  function manager() view returns (address poolManager_)
  function maxDeposit(address _receiver) view returns (uint256 assets_)
  function maxMint(address _receiver) view returns (uint256 shares_)
  function maxRedeem(address _owner) view returns (uint256 shares_)
  function maxWithdraw(address _owner) view returns (uint256 _assets)
  function mint(uint256 shares_, address _receiver) returns (uint256 assets_)
  function previewDeposit(uint256 _assets) view returns (uint256 shares_)
  function previewMint(uint256 _shares) view returns (uint256 assets_)
  function previewRedeem(uint256 _shares) view returns (uint256 assets_)
  function previewWithdraw(uint256 _assets) view returns (uint256 shares_)
  function redeem(uint256 _shares, address _receiver, address _owner) returns (uint256 assets_)
  function totalAssets() view returns (uint256 totalAssets_)
  function totalSupply() view returns (uint256)
  function transfer(address recipient, uint256 amount) returns (bool)
  function transferFrom(address sender, address recipient, uint256 amount) returns (bool)
  function withdraw(uint256 _assets, address _receiver, address _owner) returns (uint256 shares_)
`;